/**
 * Mascot Event Bus
 * Event-driven system for mascot animations triggered by exercise feedback
 */

class MascotEventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    if (!this.listeners.has(event)) return;
    const callbacks = this.listeners.get(event);
    const index = callbacks.indexOf(callback);
    if (index > -1) {
      callbacks.splice(index, 1);
    }
  }

  emit(event, data = {}) {
    if (!this.listeners.has(event)) return;
    this.listeners.get(event).forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in mascot event listener for ${event}:`, error);
      }
    });
  }
}

// Static event constants
MascotEventBus.EVENTS = {
  EXERCISE_CORRECT: 'exercise_correct',
  EXERCISE_INCORRECT: 'exercise_incorrect',
  EXERCISE_SUMMARY: 'exercise_summary',
  EXERCISE_STREAK: 'exercise_streak',           // For perfect streaks (3+ correct in a row)
  EXERCISE_PARTIAL: 'exercise_partial',          // For partial credit answers
  EXERCISE_PERFECT: 'exercise_perfect',         // For perfect score (100%)
  EXERCISE_SCORE_EXCELLENT: 'exercise_score_excellent', // For 90%+ scores
  EXERCISE_SCORE_GOOD: 'exercise_score_good',   // For 70-89% scores
  IDLE: 'idle'
};

// Export event constants separately for easier access
export const MASCOT_EVENTS = MascotEventBus.EVENTS;

// Export singleton instance
export const mascotEventBus = new MascotEventBus();
export default mascotEventBus;

